import clsx from 'clsx';
import React from 'react';

import Highlight from '@components/FeedItems/Highlight';

interface HeaderProps {
  highlight: string;
  title: string;
  titleClassName?: string;
  subTitle: string;
  subTitleClassName?: string;
}

const Header = ({ highlight, title, titleClassName, subTitle, subTitleClassName }: HeaderProps) => {
  return (
    <>
      {highlight && <Highlight highlight={highlight} className="!text-caption-md" />}
      <h1
        className={clsx(
          'my-8 text-pretty font-suisse-works text-headline-sm text-primary-black sm:text-headline-xl print:!text-headline-sm',
          titleClassName
        )}
      >
        {title}
      </h1>
      {subTitle && (
        <h3
          className={clsx(
            'm-0 font-suisse-neue text-subheadline-sm text-primary-black sm:text-subheadline-lg print:!text-subheadline-sm',
            subTitleClassName
          )}
        >
          {subTitle}
        </h3>
      )}
    </>
  );
};

export default Header;
